export const isValidHexColor = color => /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);



// WEBPACK FOOTER //
// ./src/util/isValidHexColor.js